const assignContactsToRoleBtn = document.querySelector('#assign-contacts-to-role-btn');
const assignContactsModalForm = document.querySelector('#assignRoleModalForm');
const assignContactsForm = $('#assignRoleModalForm');
const searchContactInput = document.querySelector('#searchContact');

function getContactsForRoles(searching) {
    let url = assignContactsForm.attr('data-url');
    let page = 1;

    window.axios.get(url, {params: {
            page: page,
            search: searching,
            'only-not-assigned': false,
        }}).then(({data}) => {
        let assignContactTbody = $('#assign-contact-tbody');
        assignContactTbody.html('');
        let dataList = data.data;
        $.each(dataList, function (key, item) {
            let name = item.name;
            let email = item.email;
            let id = item.id;
            let assigned = item.assigned;

            if (assigned) {
                assignContactTbody.append(
                    `<tr>
                    <td>${item.name}</td>
                    <td><a href="#">${item.email}</a></td>
                    <td>
                        <label class="is-form-check">
                            <input class="is-form-check--input"
                                name="contact"
                                value="${item.id}"
                                checked
                                type="checkbox">
                            <span class="is-form-check--input--checkmark"></span>
                        </label>
                    </td>
                </tr>`
                );
            } else {
                assignContactTbody.append(
                    `<tr>
                    <td>${item.name}</td>
                    <td><a href="#">${item.email}</a></td>
                    <td>
                        <label class="is-form-check">
                            <input class="is-form-check--input"
                                name="contact"
                                value="${item.id}"
                                type="checkbox">
                            <span class="is-form-check--input--checkmark"></span>
                        </label>
                    </td>
                </tr>`
                );
            }
        });
    })
}

if (assignContactsToRoleBtn) {
    assignContactsToRoleBtn.addEventListener('click', (e) => {
        getContactsForRoles('');
    });
}

if (assignContactsModalForm) {
    assignContactsModalForm.addEventListener('submit', (e) => {
        e.preventDefault();

        let urlSave = assignContactsForm.attr('data-save');
        let urlDelete = assignContactsForm.attr('data-delete');

        // get unchecked contacts
        let id = 0;
        $("#assignRoleModalForm input:checkbox:not(:checked)").each(function(){
            id = $(this).val();
            window.axios.delete(urlDelete, {
                params: {id}
            }).then(({data}) => {
            })
        });


        // get checked contacts
        let checkedIds = [];
        $("#assignRoleModalForm input:checkbox:checked").each(function(){
            checkedIds.push($(this).val());
        });

        window.axios.post(urlSave, {
            ids: checkedIds,
        }).then(({data: data}) => {
            if (data.success) {
                window.location.reload()
            }
        });

    });
}

if (searchContactInput) {
    searchContactInput.addEventListener('keyup', (e) => {
        let query = searchContactInput.value;
        setTimeout(function () {
            getContactsForRoles(query);
        }, 200);
    });
}

function childrenCheckboxSelectorFunction(id) {
    let isChecked = document.getElementById(id).checked;

    if (isChecked)
        document.getElementById(id).indeterminate = false;

    $('.' + id +"-child").each(function() {
        if ($(this)[0].id != "")
            document.getElementById($(this)[0].id).checked = isChecked;
        else
            $(this).attr('checked', isChecked);

        if ($(this)[0].id != "") {
            childrenCheckboxSelectorFunction($(this)[0].id);
        }
    });

    if ($('#' + id).id !== undefined)
        childCheckboxChanged(id);
}

function childCheckboxChanged(parent) {
    let siblings = $('.' + parent + '-child');
    let indeterminate = [];

    siblings.each(function(index) {
        if (! indeterminate.includes(siblings[index].checked))
            indeterminate.push(siblings[index].checked);

        if (indeterminate.includes(siblings[index].indeterminate))
            indeterminate.push(siblings[index].indeterminate);
    });

    if (indeterminate.length > 1) {
        document.getElementById(parent).indeterminate = indeterminate.includes(true);
        document.getElementById(parent).checked = indeterminate.includes(true);
    }
    else {
        if (indeterminate.length > 0)
            document.getElementById(parent).checked = indeterminate.includes(true);

        document.getElementById(parent).indeterminate = false;
    }

    //Check Grandparent
    let grandparent = $("#" + parent).data('parent');
    if (grandparent !== undefined) {
        childCheckboxChanged(grandparent);
    }
}

function selectAllChildren(element) {
    let childrenCheckboxSelector = element.classList.contains("childrenCheckboxSelector");

    let parent = element.getAttribute('data-parent');

    if (parent == undefined)
        parent = element.id;

    if (childrenCheckboxSelector)
        childrenCheckboxSelectorFunction(element.id);

    if (parent !== undefined)
        childCheckboxChanged(parent);
}

$("input[type='checkbox']").on('click', function () {
    selectAllChildren($(this)[0]);
});
